/** Subcategories onboarding video (YouTube). */
export const SUBCATEGORIES_FEATURE_YOUTUBE_ID = 'l7nYbv5HSw4';

/** Slide 2 del popup unificado (Precios Mayoristas). */
export const WHOLESALE_PRICING_ONBOARDING = {
    badge: 'Nuevo',
    title: 'Precios mayoristas',
    subtitle:
        'Motiva compras por volumen con descuentos automáticos según la cantidad que lleve el cliente.',
    benefits: [
        {
            id: 'wholesale',
            title: 'Precios al por mayor',
            description: 'Define reglas según la cantidad que compra el cliente.',
        },
        {
            id: 'discount',
            title: 'Descuentos flexibles',
            description: 'Por porcentaje o monto a restar del precio base.',
        },
        {
            id: 'scope',
            title: 'Alcance configurable',
            description: 'Aplica a toda la tienda, categorías o productos específicos.',
        },
        {
            id: 'automatic',
            title: 'Automático en la tienda',
            description: 'El cliente ve el precio actualizado en vitrina y carrito.',
        },
    ],
    desktopCallout: {
        badge: 'Nuevo',
        message: 'Función exclusiva para impulsar tus ventas al por mayor',
    },
};
/** Persisted across sessions; preserved on logout (see auth logOut). */
export const SUBCATEGORIES_VIDEO_LS_PREFIX = 'ecometri-subcategories-video-';

export const getSubcategoriesVideoSeenKey = (storeId) =>
    `${SUBCATEGORIES_VIDEO_LS_PREFIX}seen-${storeId}`;

export const hasSeenSubcategoriesVideo = (storeId) => {
    if (typeof window === 'undefined' || !storeId) return false;
    if (localStorage.getItem(getSubcategoriesVideoSeenKey(storeId)) === '1') return true;
    if (localStorage.getItem(`ecometri-subcategories-bell-seen-${storeId}`) === '1') return true;
    if (sessionStorage.getItem(`ecometri-subcategories-video-dismissed-${storeId}`) === '1') {
        return true;
    }
    return false;
};

export const markSubcategoriesVideoSeen = (storeId) => {
    if (typeof window === 'undefined' || !storeId) return;
    localStorage.setItem(getSubcategoriesVideoSeenKey(storeId), '1');
};

/** @deprecated Use hasSeenSubcategoriesVideo — kept for imports during transition */
export const isSubcategoriesBellSeen = hasSeenSubcategoriesVideo;

/** @deprecated Use markSubcategoriesVideoSeen */
export const markSubcategoriesBellSeen = markSubcategoriesVideoSeen;
